/**
 * ImageItem — demo/dev component only.
 * NOT used in production UI — items are rendered via ItemRenderer (v2/views/ItemRenderer.js).
 * Referenced in NewDesignDemo.js for component showcase purposes.
 */
import React from 'react';
import ItemCard from './ItemCard';
import { CopyIcon, TrashIcon } from '../icons';

const ImageItem = ({
  imageUrl = '',
  date,
  device,
  onClick,
  onEdit,
  onDelete,
  onCopy,
  className = '',
}) => {
  const actions = [
    onCopy && { key: 'copy', icon: CopyIcon, onClick: onCopy },
    onDelete && { key: 'delete', icon: TrashIcon, onClick: onDelete },
  ].filter(Boolean);

  return (
    <ItemCard
      date={date}
      device={device}
      actions={actions}
      onClick={onClick ?? onEdit}
      className={className}
    >
      <div className="w-full h-full flex items-center justify-center">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Clipboard content"
            crossOrigin="anonymous"
            className="w-full h-full object-cover rounded-2xl"
          />
        ) : (
          <div className="w-full h-full bg-gray-100 rounded-2xl flex items-center justify-center">
            <div className="text-gray-400 text-sm">No image</div>
          </div>
        )}
      </div>
    </ItemCard>
  );
};

export default ImageItem;
